import Vue from "vue";
import Vuex from "vuex";

import localforage from "localforage";
import VuexPersistence from "vuex-persist";

import { accessTokens } from "./modules/accessToken";
import { actions } from "./modules/action";
import { alarms } from "./modules/alarm";
import { alert } from "./modules/alert";
import { applications } from "./modules/application";
import { contacts } from "./modules/contact";
import { camOnline } from "./modules/camOnline";
import { companies } from "./modules/company";
import { configuration } from "./modules/configuration";
import { dashboards } from "./modules/dashboard";
import { downlinks } from "./modules/downlinks";
import { event } from "./modules/event";
import { featureAccess } from "./modules/featureAccess";
import { gateways } from "./modules/gateway";
import { formulas } from "./modules/formula";
import { languages } from "./modules/language";
import { logs } from "./modules/log";
import { modbus } from "./modules/modbus";
import { modules } from "./modules/modules";
import { mqtt } from "./modules/mqtt";
import { notifications } from "./modules/notification";
import { opc } from "./modules/opc";
import { reports } from "./modules/report";
import { roles } from "./modules/roles";
import { scripts } from "./modules/scripts";
import { settings } from "./modules/settings";
import { signalTests } from "./modules/signalTest";
import { slots } from "./modules/slots";
import { tag } from "./modules/tag";
import { tagData } from "./modules/tagdata";
import { templateDashboard } from "./modules/templateDashboard";
import { users } from "./modules/user";
import { tagJournal } from "./modules/tagJournal";
import { tagJournalFile } from "./modules/tagJournalFile";
import { compare } from "./modules/compare";

Vue.use(Vuex);

// Create a localforage instance (IndexedDB backend)
const forageStore = localforage.createInstance({
  name: "sensoronline", // change to your app name
});

// Vuex persistence configuration
const vuexIndexedDB = new VuexPersistence({
  key: "vuex", // name in IndexedDB
  storage: forageStore,
  asyncStorage: true,
  reducer: (state) => ({
    // Only persist what’s necessary to reduce size
    users: state.users,
    settings: state.settings,
    configuration: state.configuration,
    featureAccess: state.featureAccess,
    languages: state.languages,
  }),
});

const store = new Vuex.Store({
  modules: {
    actions,
    accessTokens,
    alarms,
    alert,
    applications,
    contacts,
    camOnline,
    companies,
    compare,
    configuration,
    dashboards,
    downlinks,
    event,
    featureAccess,
    gateways,
    formulas,
    languages,
    logs,
    modbus,
    modules,
    mqtt,
    notifications,
    opc,
    reports,
    roles,
    scripts,
    settings,
    signalTests,
    slots,
    tag,
    tagData,
    templateDashboard,
    users,
    tagJournal,
    tagJournalFile,
  },
  plugins: [vuexIndexedDB.plugin],
});

store.restored = vuexIndexedDB
  .restoreState(vuexIndexedDB.key, forageStore)
  .then((restoredState) => {
    store.replaceState(Object.assign({}, store.state, restoredState)); // Merge vuex store from indexedDB
  });

export default store;
